import { render } from "./tot-badge.vue?vue&type=template&id=4e735cd4"
import script from "./tot-badge.vue?vue&type=script&lang=js"
export * from "./tot-badge.vue?vue&type=script&lang=js"

import "./tot-badge.vue?vue&type=style&index=0&id=4e735cd4&lang=css"

import exportComponent from "/codebuild/output/src3011205126/src/emulator.totogidemos.com/frontend/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__